import { useQuery } from '@tanstack/react-query';
import type { OrderResponse } from '../types/checkout';
import { readPreviousOrders } from '../utils/previousOrdersStorage';

/**
 * Read the visitor's previous orders for a restaurant from the react-query
 * cache, seeded from localStorage so the list survives a hard refresh.
 * `enabled: false` — this hook never fetches; the cache is written by the
 * checkout flow (see CheckoutPage.onSubmit).
 */
export function usePreviousOrders(restaurantId: string | undefined) {
  const { data = [] } = useQuery<OrderResponse[]>({
    queryKey: ['publicOrders', restaurantId],
    queryFn: () => readPreviousOrders(restaurantId),
    enabled: false,
    initialData: () => readPreviousOrders(restaurantId),
  });
  return data;
}
